import Reminder20 from '@carbon/icons-react/es/reminder/20';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { TimesheetDueReminder } from 'api/notifications/meta';
import { Strong, useNotificationMessage } from '../../basics';
import { WeekViewLink } from './week-view';

export const TimesheetDueReminderView: FC<{
  meta: TimesheetDueReminder;
  userId: number;
}> = ({ meta: { start }, userId }) => (
  <FormattedMessage
    id="notifications.messages.timesheet_due_reminder"
    values={{
      reminder: (
        <>
          <Reminder20 />
          <Strong>{useNotificationMessage('reminder')}</Strong>
        </>
      ),
      week: <WeekViewLink start={moment(start)} userId={userId} />,
    }}
  />
);
